import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	ButtonGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewUser, updateUser } from '../../../../slices/user/thunk';
import { setRequireCloseModal } from '../../../../slices/user/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import RolesSelect from '../../../../Components/General/Selects/RolesSelect';
import {
	getEstablishmentList as getEstablishmentListApi,
	getEstablishmentTypeList
} from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import { getRolesList } from '../../../../helpers/auth/backend_helper';
import { getEstablishmentList } from '../../../../slices/thunks';

const UserForm = ({
	dataUser,
	initialUserData,
	isEdit,
	handleToggleModal,
	onUserCreated,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const [selectedVisibility, setselectedVisibility] = useState(null);
	const [permissionType, setPermissionType] = useState(null);

	const [establishmentList, setEstablishmentList] = useState([]);
	const [establishmentListByTypes, setEstablishmentListByTypes] = useState([]);
	const [selectedEstablishments, setSelectedEstablishments] = useState([]);
	const [onlyEstablishmentActive, setOnlyEstablishmentActive] = useState(false);
	const handleEstablishmentsSelected = (optionSelected) => {
		setSelectedEstablishments(optionSelected);
	};

	function handleSelectVisibility(selectedVisibility) {
		setselectedVisibility(selectedVisibility);
	}

	const loadingEstablishments = async () => {
		try{
			const response = await dispatch(getEstablishmentList({ status_code: 'ACT' })).unwrap();
			
			const establishments = response.map(establishment => {
				return { value: establishment._id, label: establishment.name, item: establishment }
			});
			setEstablishmentList(establishments);
		} catch (err) { 
			console.error('Error al cargar establecimientos:', err);
		}
	}

	const selectorUser = createSelector(
		state => state.Users,
		user => ({
			isAdding: user.isAdding,
			isAdded: user.isAdded,
			isUpdating: user.isUpdating,
			isUpdated: user.isUpdated,
			isLoadingList: user.isLoadingList,
			requireCloseModal: user.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorUser);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			username: (dataUser && dataUser.username) || '',
			email: (dataUser && dataUser.email) || '',
			first_name: (dataUser && dataUser.first_name) || (!isEdit ? initialUserData?.first_name || '' : ''),
			last_name: (dataUser && dataUser.last_name) || (!isEdit ? initialUserData?.last_name || '' : ''),
			disabled: (dataUser && dataUser.disabled) || false,
			role: (dataUser && dataUser.role) || '',
			password: '',
			active_directory: false,
			permission_by_establishment_type: '',
			permission_by_establishment: '',
			permission_type_id: '',
			establishment_type_ids: [],
			establishment_ids: [],
			establishment_default_id: ''
		},
		validationSchema: Yup.object({
			permission_type_id: Yup.string().required('Campo requerido'),
			username: Yup.string().required('Campo requerido'),
			email: Yup.string()
				.email(' El email no es válido')
				.required('Campo requerido'),
			first_name: Yup.string().required('Campo requerido'),
			last_name: Yup.string().required('Campo requerido'),
			password: isEdit
				? Yup.string()
				: Yup.string().required('Campo requerido'),
			role: Yup.string().required('Campo requerido'),
			disabled: Yup.boolean(),
			establishment_type_ids: Yup
				.array()
				.of(Yup.string()),
			establishment_ids: Yup
				.array()
				.of(Yup.string()),
			establishment_default_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: async values => {



			if (isEdit) {
				// if there is no change in the password, then don't send it
				const updatedUser = {
					username: values.username,
					email: values.email,
					first_name: values.first_name,
					last_name: values.last_name,
					full_name: `${values.first_name} ${values.last_name}`,
					disabled: values.disabled,
					role: values.role,
					establishment_type_ids: (
						values.permission_type_id === 2 ?
							values.establishment_type_ids
							: []
					),
					establishment_ids: (
						values.permission_type_id === 3 ?
							values.establishment_ids : []
					),
					active_directory: values.active_directory,
					permission_by_establishment_type: (
						values.permission_type_id === 2
							? true : false
					),
					permission_by_establishment: (
						values.permission_type_id === 3
							? true : false
					),
					...(values.password === '' ? {} : { password: values.password }),
					establishment_default_id: values.establishment_default_id
				};
				dispatch(
					updateUser({ username: dataUser.username, user: updatedUser })
				);
			} else {
				const newUser = {
					username: values.username,
					email: values.email,
					first_name: values.first_name,
					last_name: values.last_name,
					full_name: `${values.first_name} ${values.last_name}`,
					disabled: false,
					password: values.password,
					role: values.role,
					establishment_type_ids: (
						values.permission_type_id === 2 ?
							values.establishment_type_ids
							: []
					),
					establishment_ids: (
						values.permission_type_id === 3 ?
							values.establishment_ids : []
					),
					permission_by_establishment_type: (
						values.permission_type_id === 2 ? true : false
					),
					permission_by_establishment: (
						values.permission_type_id === 3 ? true : false
					),
					active_directory: values.active_directory,
					establishment_default_id: values.establishment_default_id
				};

				if (typeof onUserCreated === 'function') {
					try {
						const createdUser = await dispatch(addNewUser(newUser)).unwrap();
						dispatch(setRequireCloseModal(false));
						onUserCreated(createdUser);
					} catch (error) {
						// Error toast is handled in thunk.
					}
					return;
				}

				dispatch(addNewUser(newUser));
			}
		},
	});

	useEffect(() => {
		if (typeof onUserCreated === 'function') {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
			}
			return;
		}

		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [dispatch, handleToggleModal, isOpen, onUserCreated, requireCloseModal]);

	useEffect(() => {
		if(dataUser){
			setPermissionType(1);
			if(dataUser?.permission_by_establishment_type){
				setPermissionType(2);
			}
			if(dataUser?.permission_by_establishment){
				setPermissionType(3);
			}
		}
	}, [dataUser])

	useEffect(() => {
		loadingEstablishments();
	}, []);

	// Effect to handle of establishment list filtered by types 
	// when selection of establishment types and permission type changed.
	useEffect(() => {
		if(
			validation.values.permission_type_id === 2
		){
			setEstablishmentListByTypes(
				establishmentList.filter(
					establishmentItem =>
						validation.values.establishment_type_ids
							.includes(establishmentItem.item.establishment_type_id)

				)
			)
		}
	}, [
		validation.values.permission_type_id,
		validation.values.establishment_type_ids
	])

	useEffect(() => {
	}, [establishmentListByTypes])

	useEffect(() => {
		if(validation.values.permission_type_id === 3){
			if(selectedEstablishments.length == 1){
				setOnlyEstablishmentActive(selectedEstablishments[0].item._id);
			}
		}
	}, [
		validation.values.permission_type_id,
		selectedEstablishments
	])

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={4}>
								<Label for='username-field' className='form-label'>
									Nombre usuario
								</Label>
								<Input
									name='username'
									id='username-field'
									className='form-control'
									placeholder='Ingrese el Nombre de Usuario'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.username || ''}
									invalid={
										validation.touched.username &&
										validation.errors.username
											? true
											: false
									}
								/>
								{validation.touched.username &&
								validation.errors.username ? (
									<FormFeedback type='invalid'>
										{validation.errors.username}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={4}>
								<Label for='email-field' className='form-label'>
									E-Mail
								</Label>
								<Input
									name='email'
									id='email-field'
									className='form-control'
									placeholder='Ingrese el email'
									type='email'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.email || ''}
									invalid={
										validation.touched.email &&
										validation.errors.email
											? true
											: false
									}
								/>
								{validation.touched.email && validation.errors.email ? (
									<FormFeedback type='invalid'>
										{validation.errors.email}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={4}>
								<Label for='first_name-field' className='form-label'>
									Nombre
								</Label>
								<Input
									name='first_name'
									id='first_name-field'
									className='form-control'
									placeholder='Ingrese el Nombre'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.first_name || ''}
									invalid={
										validation.touched.first_name &&
										validation.errors.first_name
											? true
											: false
									}
								/>
								{validation.touched.first_name &&
								validation.errors.first_name ? (
									<FormFeedback type='invalid'>
										{validation.errors.first_name}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={4}>
								<Label for='last_name-field' className='form-label'>
									Apellido
								</Label>
								<Input
									name='last_name'
									id='last_name-field'
									className='form-control'
									placeholder='Ingrese el Apellido'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.last_name || ''}
									invalid={
										validation.touched.last_name &&
										validation.errors.last_name
											? true
											: false
									}
								/>
								{validation.touched.last_name &&
								validation.errors.last_name ? (
									<FormFeedback type='invalid'>
										{validation.errors.last_name}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={4}>
								<Label for='password-field' className='form-label'>
									Contraseña
								</Label>
								<Input
									name='password'
									id='password-field'
									className='form-control'
									placeholder='Ingrese la contraseña'
									type='password'  
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.password || ''}
									invalid={
										validation.touched.password &&
										validation.errors.password
											? true
											: false
									}
								/>
								{validation.touched.password &&
								validation.errors.password ? (
									<FormFeedback type='invalid'>
										{validation.errors.password}
									</FormFeedback>
								) : null}
							</Col>
							<Row className='pt-3'>
								{isEdit && (
									<Col lg={3}>
										<FormGroup className='d-flex align-items-center'>
											<Label
												for='disabled-field'
												className='form-label'
											>
												<Input
													id='disabled-field'
													name='disabled'
													type='checkbox'
													validate={{ required: { value: true } }}
													onChange={validation.handleChange}
													onBlur={validation.handleBlur}
													value={validation.values.disabled || ''}
													invalid={
														validation.touched.disabled &&
														validation.errors.disabled
															? true
															: false
													}
												/>
												¿Usuario desactivado?
											</Label>
											{validation.touched.disabled &&
											validation.errors.disabled ? (
												<FormFeedback type='invalid'>
													{validation.errors.disabled}
												</FormFeedback>
											) : null}
										</FormGroup>
									</Col>
								)}
								<Col lg={3}>
									<FormGroup className='d-flex align-items-center'>
										<Label
											for='active_directory-field'
											className='form-label'
										>
											<Input
												id='active_directory-field'
												name='active_directory'
												type='checkbox'
												validate={{ required: { value: true } }}
												onChange={validation.handleChange}
												onBlur={validation.handleBlur}
												value={
													validation.values.active_directory || ''
												}
												invalid={
													validation.touched.active_directory &&
													validation.errors.active_directory
														? true
														: false
												}
											/>
											¿Usuario de Active Directory?
										</Label>
										{validation.touched.active_directory &&
										validation.errors.active_directory ? (
											<FormFeedback type='invalid'>
												{validation.errors.active_directory}
											</FormFeedback>
										) : null}
									</FormGroup>
								</Col>
							</Row>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row className='g-3'>
							<Col lg={6}>
								<OSelect
									key={`role` || ''}
									label='Perfil de Usuario'
									id='role'
									name='role'
									value={dataUser.role || ''}
									requestApi={() => getRolesList()}
									validation={validation}
								/>
							</Col>
							<hr></hr>
							<Col lg={6}>
								<OSelect
									key={`permission_type_id${permissionType || ''}` || ''}
									label='Permisos de Establecimientos'
									id='permission_type_id'
									name='permission_type_id'
									value={permissionType || ''}
									itemsSelect={[
										{ value: 1, label: 'Todos', item: { _id: 1, name: 'Todos' } },
										{ value: 2, label: 'Por tipo de establecimiento', item: { _id: 2, name: 'Por tipo de establecimiento' } },
										{ value: 3, label: 'Por establecimientos', item: { _id: 3, name: 'por Establecimientos' } },
									]}
									// onSelect={(item) => setPermissionType(item._id)}
									disabled={false}
									validation={validation}
								/>
							</Col>
							{(validation.values.permission_type_id === 2 ? 
								<Col lg={6}>
										<OSelect
											key={`establishment_type_ids` || ''}
											label='Tipos de Establecimiento'
											id='establishment_type_ids'
											name='establishment_type_ids'
											value={dataUser.establishment_type_ids || ''}
											requestApi={() => getEstablishmentTypeList()}
											validation={validation}
											isMulti
										/>
								</Col> : null

							)}
							{(validation.values.permission_type_id === 3 ? 
								<Col lg={6}>
									<OSelect
										key={`establishment_ids` + establishmentList || ''}
										label='Establecimientos'
										id='establishment_ids'
										name='establishment_ids'
										value={dataUser.establishment_ids || ''}
										itemsSelect={establishmentList}
										validation={validation}
										onSelect={handleEstablishmentsSelected}
										isMulti
									/>
								</Col> : null
							)}
							<Col lg={6}>
								<OSelect
									key={
										`establishment_default_id` +
										validation.values.permission_type_id +
										establishmentList +
										selectedEstablishments +
										establishmentListByTypes +
										onlyEstablishmentActive ||
										''
									}
									label='Establecimiento Por Defecto'
									id='establishment_default_id'
									name='establishment_default_id'
									value={ onlyEstablishmentActive || dataUser?.establishment_default_id || ''}
									itemsSelect={() => {
										if(validation.values.permission_type_id === 1) return establishmentList
										if(validation.values.permission_type_id === 2) return establishmentListByTypes
										if(validation.values.permission_type_id === 3) return selectedEstablishments
										return []
									}}
									validation={validation}
								/>
							</Col>
							
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Actualizar' : 'Agregar'} Usuario
					</button>
				</div>
			</div>
		</Form>
	);
};

export default UserForm;
